import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/core/services/api.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { RoutingService } from 'src/app/core/services/routing.service';
import { Notify } from 'notiflix';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, OnDestroy {

  public registerForm: UntypedFormGroup;
  public submitted = false;
  public loading = false;
  public countries: any = [];
  public psvisible: boolean = false;
  public psConfirmvisible: boolean = false;
  public currentStep: number = 1;
  public totalSteps: number = 4;
  public referralToken: string | null = null;
  private wasLightMode: boolean = false;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _auths: AuthService,
    private _rs: RoutingService,
    private _apis: ApiService,
    private _route: ActivatedRoute
  ) {
    if (this._auths.token) {
      this._rs.home();
    }

    this._apis.countries().subscribe(
      (res) => { this.countries = res.data; },
      (err) => { console.log(err); }
    );

    this.registerForm = this._formBuilder.group({
      sex: ['man'],
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(30)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.minLength(7), Validators.maxLength(15)]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(30)]],
      repeatPassword: ['', [Validators.required]],
      dob: [''],
      country: ['US'],
      address: [''],
      city: [''],
      state: [''],
      interest1: [''],
      interest2: [''],
      interest3: [''],
      interest4: [''],
      interest5: [''],
      interest6: [''],
    });
  }

  ngOnInit(): void {
    if (document.body.classList.contains('light-mode')) {
      this.wasLightMode = true;
      document.body.classList.remove('light-mode');
    }
    document.body.classList.add('login-v2-theme');

    const head = document.getElementsByTagName('head')[0];

    const link1 = document.createElement('link');
    link1.id = 'login-css-1';
    link1.rel = 'stylesheet';
    link1.href = '/assets/css/main.min.css';
    head.appendChild(link1);

    const link2 = document.createElement('link');
    link2.id = 'login-css-2';
    link2.rel = 'stylesheet';
    link2.href = '/assets/css/login-style.css';
    head.appendChild(link2);

    const link3 = document.createElement('link');
    link3.id = 'login-css-3';
    link3.rel = 'stylesheet';
    link3.href = '/assets/css/style.css';
    head.appendChild(link3);

    this._route.queryParams.subscribe(params => {
      this.referralToken = params['token'] || null;
    });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('login-v2-theme');
    if (this.wasLightMode) {
      document.body.classList.add('light-mode');
    }
    document.getElementById('login-css-1')?.remove();
    document.getElementById('login-css-2')?.remove();
    document.getElementById('login-css-3')?.remove();
  }

  get f() { return this.registerForm.controls; }

  public nextStep(): void {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
    }
  }

  public prevStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  public onSubmit(e?: Event): void {
    if (e) e.preventDefault();
    this.submitted = true;

    if (this.registerForm.value.password !== this.registerForm.value.repeatPassword) {
      Notify.failure('Passwords do not match!');
      return;
    }

    if (!this.registerForm.value.name || !this.registerForm.value.email || !this.registerForm.value.password) {
      Notify.failure('Please fill in all required fields!');
      return;
    }

    this.loading = true;

    const payload: any = {
      sex: this.registerForm.value.sex || 'man',
      name: this.registerForm.value.name,
      email: this.registerForm.value.email,
      phone: this.registerForm.value.phone,
      password: this.registerForm.value.password,
      dob: this.registerForm.value.dob || null,
      country: this.registerForm.value.country || 'US',
      address: this.registerForm.value.address || '',
      city: this.registerForm.value.city || '',
      state: this.registerForm.value.state || '',
      interest1: this.registerForm.value.interest1 || '',
      interest2: this.registerForm.value.interest2 || '',
      interest3: this.registerForm.value.interest3 || '',
      interest4: this.registerForm.value.interest4 || '',
      interest5: this.registerForm.value.interest5 || '',
      interest6: this.registerForm.value.interest6 || '',
    };

    if (this.referralToken) {
      payload.referToken = this.referralToken;
    }

    this._apis.register(payload).subscribe(
      (res: any) => {
        this.loading = false;
        Notify.success('Registration successful! Welcome to FlyDnA!');
        setTimeout(() => {
          this._rs.login();
        }, 1500);
      },
      (err: any) => {
        this.loading = false;
        const msg = err?.error?.error || 'Registration failed. Please try again.';
        Notify.failure(msg);
      }
    );
  }

  public togglePasswordVisibility() { this.psvisible = !this.psvisible; }
  public toggleConfirmPasswordVisibility() { this.psConfirmvisible = !this.psConfirmvisible; }
}